module.exports = __webpack_public_path__ + "static/media/warehouse.42463d5d.png";